<script>
  import FilterDialog2 from "./FilterDialog2.svelte";

  export let GanttStore

  export let filterName

  const {
    Filters,
    FilterableItems,
  } = GanttStore
  let isFilterDialogOpen = false

  $: items = $FilterableItems[filterName]
</script>

<button on:click={() => isFilterDialogOpen = true}>
  {#if $Filters[filterName].isFilterOn()}
    <img src="/assets/icons/icon_filter_on.svg" alt="filter on icon"/>
  {:else}
    <img src="/assets/icons/icon_filter_off.svg" alt="filter off icon"/>
  {/if}
</button>
{#if isFilterDialogOpen}
  <FilterDialog2
    target={$Filters[filterName].target}
    targetTranslationKey={$Filters[filterName].targetTranslationKey}
    onFilterDetermined={items => {
      const filter = $Filters[filterName]
      filter.items = items
      Filters.update(filters => ({...filters, [filterName]: filter}))
      isFilterDialogOpen = false
    }}
    onClose={() => isFilterDialogOpen = false}
    bind:items={items}
  />
{/if}

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
</style>